import React from 'react';
import { Form, Checkbox, Input, Select } from 'antd'
import { FACTURA } from '../../../../common/types/tipoComprobanteType';

const InputGroup = Input.Group;
const { Option } = Select;

export default function Footer(props) {
    return (
        <div className="row">
            <div className={"col-md-9"}>
   
            </div>
   
            <div className="col-md-3 pt-10">

        

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total Retención</label>
                        <div>{props.onGetFieldValue('sumaSubTotal').toFixed(2)}</div>
                    </div>
                </div>
     

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total</label>
                        <div>{props.onGetFieldValue('sumaTotal').toFixed(2)}</div>
                    </div>
                </div>

            </div>
        </div>
    );
}